import { inject, observer } from 'mobx-react';
import AgGrid from '../../../common/components/ag-grid/ag-grid';
import { AppConstants } from '../../../common/APIConstants';
import React from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import CheckboxRenderer from '../../../common/CheckboxRenderer';
import SmartSelectClearable from '../../../common/SmartSelectClearable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faCopy,
  faFileExport,
  faPlus,
  faSave,
  faSync,
  faTrash,
  faEye,
} from '@fortawesome/free-solid-svg-icons';
import commonstore from '../../../common/commonstore';
import VendortTemplateDataStore from '../store/generator-vendor-template-store';
import {
  DateFormatter,
  DateTimeFormatter
} from '../../../common/DateFormatter';
import {
  DecimalFormatter,
  NumberFormatter,
  DecimalAllDigitsFormatter
} from '../../../common/NumberFormatter';
import {NumericCellEditor} from '../../../common/NumericCellEditor';
import {DecimalCellEditor} from '../../../common/DecimalCellEditor';

@inject('VendortTemplateDataStore')
@observer
class VendortTemplateScreen extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      gridOptions: {
      
        rowSelection: 'single',
        singleClickEdit: true,
        pagination: false,
        stopEditingWhenGridLosesFocus: true,
        autoSizeAllColumns: true,
        floatingFilter: true,
        enableRangeSelection: true,
        rowGroupPanelShow: 'always',
        suppressContextMenu: true,
        getRowStyle: this.getRowStyleScheduled,
        statusBar: {
          statusPanels: [
            {
              statusPanel: 'agTotalAndFilteredRowCountComponent',
              align: 'left'
            },
            {
              statusPanel: 'agAggregationComponent',
              statusPanelParams: {
                aggFuncs: ['avg', 'count', 'min', 'max', 'sum']
              }
            }
          ]
        },
        sideBar: {
          toolPanels: [
            {
              id: 'columns',
              labelDefault: 'Columns',
              labelKey: 'columns',
              iconKey: 'columns',
              toolPanel: 'agColumnsToolPanel'
            }
          ],
          showToolPanel: false
        },
        defaultColDef: {
          enableRowGroup: true,
          enablePivot: true,
          enableValue: true,
          sortable: true,
          filter: true,
          resizable: true
        },
        frameworkComponents: {
          SmartSelectClearable: SmartSelectClearable,
          booleanCellEditor: CheckboxRenderer,        
          numericCellEditor:NumericCellEditor,
          decimalCellEditor: DecimalCellEditor,
          dateFormatter: DateFormatter,
          dateTimeFormatter:DateTimeFormatter
        }
      },
      editRowData: '',
      rowSelected: false,
    vendorlistTxt:'',
    monthYearTxt:'',
    isSubmitting: false,
    currentColumnDef:[],
    
    };
  }
getRowStyleScheduled =(params) =>{
  

  
    return null;
};
  setColumnDef= async() => {
    const { CommonStore, VendortTemplateDataStore } = this.props;
    const parentScreenName = this.props.path.split('/').pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    //const currentScreenChildren = this.getCurrentScreenChildren();
    await VendortTemplateDataStore.setColumnDef(currentScreen, CommonStore);
  };
  getCurrentScreenChildren = () => {
    const parentScreenName = this.props.path.split('/').pop();
    const currentScreenChildren = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.parent === parentScreenName
    );

    return currentScreenChildren;
  };
  getCurrentScreenChildrenByNm = (screenName) => {
    const parentScreenName = this.props.path.split('/').pop();
    const currentScreenChildren = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName && x.screen.name==screenName
    );

    return currentScreenChildren;
  };
  handleVendorChange= (e) => {
    var vendorTxt= e.target.value;
    this.setState({vendorlistTxt: vendorTxt});    
    VendortTemplateDataStore.resetVendorData();    
    e.preventDefault();
  };
  handleMonthYearChange= (e) => {
    this.setState({monthYearTxt: e.target.value});
    VendortTemplateDataStore.resetVendorData();
    e.preventDefault();
  };
  getVendorTemplateData = async() => {
    this.setState({ rowSelected: false, editRowData:'' });
    const { CommonStore, VendortTemplateDataStore } = this.props;
    const {vendorlistTxt, monthYearTxt} = this.state;
    const parentScreenName = this.props.path.split('/').pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    await VendortTemplateDataStore.getScreenData(currentScreen,vendorlistTxt, monthYearTxt, CommonStore);
  }
  onSelectionChanged = async (e) => {
    const selectedRow = this.state.gridOptions.api.getSelectedRows();
    this.setState({ rowSelected: selectedRow.length, editRowData:selectedRow[0] });
  }
 
  render() 
  {
  
    const { headerDetails, screenRowData, hasScreenData,screenColumnDefinitions } = this.props.VendortTemplateDataStore;
    const parentScreen = this.getCurrentScreenParent();
   let colDef = screenColumnDefinitions['GeneratorVendorTemplate'];

    const {isSubmitting,  monthYearTxt} = this.state;
    const isSubmitEnabled = ( monthYearTxt!='')?false:true;
    return (
      <div className="col-md-12">
        <div className="container cb-title-container">
          <h3 className="cb-title">{parentScreen.screen.title}</h3>
        </div> 
        <div className="col-md-12">
        <div className="row nglteam-header-row  sticky-top rounded">
          <div className="col-md-4">
            <div className="row">
            <div className="col-md-3">
            <label className="nglteam-header-row-label">Vendor:</label><br />
            </div>
            <div className="col-md-3">
            <select value={this.state.selectedFacility} onChange={this.handleVendorChange}
            value={this.state.vendorlistTxt}>
            <option key="" value="">
                            All Vendor
                          </option>
                          {headerDetails.vendorDpDwnList.map((option) => (
                            <option key={option.vendorName} value={option.vendorName}>
                              {option.vendorName}
                            </option>
                          ))}
          </select>
          </div>
          </div>
          </div>
          <div className="col-md-4">
          <div className="row">
            <div className="col-md-4">
            <label className="nglteam-header-row-label">Month&Year:</label><br />
            </div>
            <div className="col-md-6">
             <select value={this.state.selectedFacility} onChange={this.handleMonthYearChange}>
            <option key="" value="">
                            Select Month&Year
                          </option>
                          {headerDetails.monthDpDwnList.map((option) => (
                            <option key={option.id} value={option.id}>
                              {option.name}
                            </option>
                          ))}
          </select>
          </div>
          </div>
          </div>
          <div className="col-md-1">
            <div className="row">
          <button
                  type="submit"
                  disabled={isSubmitting || isSubmitEnabled}
                  className="nomination-btnsz btn btn-primary"
                  onClick={this.getVendorTemplateData}
                >
                  {isSubmitting && (
                    <span className="spinner-border spinner-border-sm mr-1"></span>
                  )}
                  Search
                </button>
                </div>
            </div>
          </div>
          </div>
          <div className="row">
             { screenRowData.VendorData && (
              <AgGrid
                gridID={"vendorTemplateData"}
                gridOptions={this.state.gridOptions}
                columnDefs={colDef}
                rowData={screenRowData.VendorData}
                onSelectionChanged={this.onSelectionChanged}
                onCellValueChanged={this.onCellValueChanged.bind(this)}
              />
    )}
            </div>
            <div className="row btn-toolbar pull-right">
            <button
                  type="save"
                  className="btn btn-primary nomination-btnsz"
                  onClick={this.saveVendorTemplateData}
                  disabled={!hasScreenData}
                >
                 Save
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-grid active"
                  aria-expanded="false"
                  disabled= {!hasScreenData}
                  onClick={this.exportToExcel}
                >
                  Export
                </button>
           
            </div>
          </div>
    );
  }
  saveVendorTemplateData = async () => {
    // console.log("col state", JSON.stringify(this.state.towerKPIGridOptions.columnApi.getColumnState()))
    const { vendorlistTxt} = this.state;
    const { CommonStore, VendortTemplateDataStore } = this.props;
    
    const parentScreenName = this.props.path.split('/').pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    await VendortTemplateDataStore.saveScreenData(currentScreen, CommonStore);
    await this.getVendorTemplateData();
  };
  onCellValueChanged = (e) => {
   
    if (e.newValue !== null && e.oldValue != e.newValue) {
      this.state.gridOptions.api.refreshCells();
    }
    else {
      e.node.setDataValue(e.colDef.field, e.oldValue);
      this.state.gridOptions.api.refreshCells();
    }
    e.node.setDataValue("IsModified", true);  
    e.node.data.IsModified = true;
  };
  exportToExcel =  () => {
    const { vendorlistTxt} = this.state;
    const { CommonStore, VendortTemplateDataStore } = this.props;
    
    const parentScreenName = this.props.path.split('/').pop();
    const currentScreen = this.props.CommonStore.screenDetails.filter(
      (x) => x.screen.name === parentScreenName
    );
    
    let params = {
      allColumns: false,
      onlySelected: false,
      onlySelectedAllPages: false,
      shouldRowBeSkipped: false,
      skipFooters: false,
      skipGroups: true,
      skipHeader: false,
      skipPinnedTop: false,
      skipPinnedBottom: false,
      fileName: parentScreenName
    };
    var today = new Date();
    const formattedDate = moment(today).format('YYYYMMDDhhmmss');
    const currentSheet =parentScreenName;
    let fileNameExcelExport= currentSheet+'_Export_All_'+formattedDate+'';
   
     this.state.gridOptions.api.exportDataAsExcel({
      fileName:fileNameExcelExport,
      sheetName: currentSheet,
      
    })
    
  };
  
  componentDidMount = async () => {
    await this.refreshHeader();
    await this.setColumnDef();
  };
  refreshHeader = async () => {
    const { CommonStore, VendortTemplateDataStore } = this.props;
    await VendortTemplateDataStore.getHeaderData(CommonStore);
  };
  getCurrentScreenParent = () => {
    const parentScreenName = this.props.path.split('/').pop();
    const parentScreen = this.props.CommonStore.screenDetails.find(
      (x) => x.screen.name === parentScreenName
    );

    return parentScreen;
  };

 
}
export default VendortTemplateScreen;